<template>
  <div class="table-history">
    <div class="buttons">
      <button @click="openOrdersfn" class="solid-gray-btn" :class="{'gray-btn' : select === 'openOrders'}">
        سفارشات باز
      </button>

      <button @click="orderHistoryfn" class="solid-gray-btn" :class="{'gray-btn' : select === 'orderHistory'}">
        تاریخچه سفارشات
      </button>

      <button @click="tradeHistoryfn" class="solid-gray-btn" :class="{'gray-btn' : select === 'tradeHistory'}">
        تاریخچه معاملات
      </button>

    </div>
    <div class="main-table">
      <table>
        <tr class="sticky">
          <th style="text-align: right">بازار</th>
          <th class="hide-under-600">زمان و تاریخ</th>
          <th class="hide-under-600">سمت</th>
          <th class="hide-under-600">نوع</th>
          <th>قیمت واحد</th>
          <th>مقدار</th>
          <th class="hide-768">کارمزد</th>
          <th class="hide-under-400">مبلغ کل</th>
          <th class="hide-768" v-if="select === 'openOrders'">مقدار پر شده</th>
          <th style="text-align: left ; padding-left: 15px" v-if="select === 'openOrders'">لغو همه</th>
          <th v-if="select === 'orderHistory'">وضعیت</th>
          <th v-if="select === 'tradeHistory'">سود / زیان</th>
        </tr>

        <tr v-for="(item ,index) in dataTable" :key="index">
          <td style="text-align: right">{{ item.market }}</td>
          <td class="hide-under-600">{{ item.date }}</td>
          <td class="hide-under-600" :class="{'red' : item.side === 'فروش' , 'green' : item.side === 'خرید'}">
            {{ item.side }}
          </td>
          <td class="hide-under-600">{{ item.type }}</td>
          <td>{{ item.unitprice }}</td>
          <td>{{ item.amount }}</td>
          <td class="hide-768">{{ item.fee }}</td>
          <td class="hide-under-400">{{ item.wholeprice }}</td>
          <td class="hide-768" v-if="select === 'openOrders'">{{ item.value }}</td>
          <td  style="text-align: left ; padding-left: 15px" class="red" v-if="select === 'openOrders'">{{ item.cancel }}</td>
          <td :class="{'red' : item.statuse === 'لغوشده' , 'green' : item.statuse ===  'تکمیل شده' , 'yellow' : item.statuse === 'انقضا'}"
              v-if="select === 'orderHistory'">{{ item.statuse }}
          </td>
          <td class="number" :class="{'red' : item.rivals < 0 , 'green' : item.rivals > 0 }" v-if="select === 'tradeHistory'">
            {{ item.rivals }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "history-table",
  data() {
    return {
      select: 'openOrders',

      dataTable: [],

      openOrders: [
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          cancel: 'لغو سفارش'
        },
      ],

      orderHistory: [
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'لغوشده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'انقضا'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'تکمیل شده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'لغوشده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'انقضا'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'تکمیل شده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'لغوشده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'انقضا'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'تکمیل شده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'لغوشده'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'انقضا'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          statuse: 'تکمیل شده'
        },
      ],

      tradeHistory: [
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: -57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: -57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: -57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          rivals: 57000
        },
      ]
    }
  },

  methods: {

    openOrdersfn() {
      this.select = 'openOrders';
      this.dataTable = this.openOrders
    },

    orderHistoryfn() {
      this.select = 'orderHistory';
      this.dataTable = this.orderHistory
    },

    tradeHistoryfn() {
      this.select = 'tradeHistory';
      this.dataTable = this.tradeHistory
    }

  },

  created() {
    this.dataTable = this.openOrders
  }
}
</script>

<style lang="scss" scoped>
//public class
.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.table-history {
  display: flex;
  flex-direction: column;
  gap: 30px;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  .buttons {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 30px;
    gap: 8px;

    button {
      width: 104px;
      height: 25px;
    }
  }

  .main-table {
    max-height: 400px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .sticky{
      position: sticky;
      top: 0;
      background-color:#0C1527
    }

    table {
      table-layout: fixed;
      color: #FFFFFF;

      tr{
        height: 47px;
      }

      th {
        text-align: center;
        font-size: clamp(12px, 2vw, 14px);
      }

      td {
        text-align: center;
        font-size: clamp(12px, 2vw, 14px);
      }
    }
  }
}

@media (max-width: 600px) {
  .hide-under-600 {
    display: none;
  }

  .hide-under-400 {
    display: none;
  }
}

@media (max-width: 768px) {
.hide-768{
  display: none !important;
}
}
</style>